<template>
  <div class="login">
    <div v-if="!loggingIn">
      <p v-if="$route.query.redirect" class="error">
        You need to login first.
      </p>
      <form @submit.prevent="login">
        <button type="submit" class="btn-login"></button>
        <p v-if="error" class="error">Unable to login to slack.</p>
      </form>
    </div>
    <SvgLoading v-if="loggingIn"></SvgLoading>
  </div>
</template>

<script>
import SvgLoading from '@/assets/SvgLoading';
import {
  login,
  getToken,
} from '@/auth';

export default {
  components: { SvgLoading },
  created() {
    if (this.$route.query.error && this.$route.query.error.length > 0) {
      this.error = true;
    }
    if (this.$route.query.code && this.$route.query.code.length > 0) {
      this.loggingIn = true;
      login(this.$route.query.code)
        .then(() => {
          this.$router.replace(this.$route.query.redirect || '/');
          this.sendTokenToCordovaPlugin();
        })
        .catch(() => {
          this.error = true;
          this.loggingIn = false;
        });
    }
  },
  data() {
    return {
      error: false,
      loggingIn: false,
    };
  },
  methods: {
    login() {
      this.loggingIn = true;
      login()
        .then(() => {
          this.$router.replace(this.$route.query.redirect || '/');
          this.sendTokenToCordovaPlugin();
        })
        .catch(() => {
          this.error = true;
          this.loggingIn = false;
        });
    },
    sendTokenToCordovaPlugin() {
      walter.setToken(getToken(), (message) => {
        if (message !== 'success') {
          console.error('unable to send token to cordova plugin', message);
        }
      }, (error) => {
        console.error('unable to send token to cordova plugin', error);
      });
    },
  },
};
</script>

<style scoped>
.login {
  position: relative;
  min-height: 300px;
  margin-top: 10vh;

  text-align: center;
}

.btn-login {
  width: 172px;
  height: 40px;

  border: none;

  background: url('~@/assets/sign_in_with_slack.png');
}

.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue